<div class="flex-center">
  <div class="contentWidth">
    <div style="height: calc(90vh - 100px); overflow-y: auto;">
      <form [formGroup]="CSRForm" autocomplete="off">
        <ng-container formArrayName="CSRRows">
          <table #objTable
            mat-table
            matSort
            [dataSource]="dataSource"
            class="table-add-butt-header-orange mat-elevation-z8 mat-table-custom">

            <ng-container matColumnDef="headertitle">
              <th class="title-col" mat-header-cell *matHeaderCellDef colspan="9">
                <div class="pull-left">
                  <h4>Controller Software</h4>
                </div>
              </th>
            </ng-container>
            <ng-container matColumnDef="headeraddbutton">
              <th class="butt-col" mat-header-cell *matHeaderCellDef>
                <div class="OrangeButton">
                  <button mat-raised-button (click)="addNewRow()"
                    matTooltip="Add Release" class="button-color-fix pull-right">
                    <mat-icon class="icon-color-fix icon-padding-fix">add_box</mat-icon>
                  </button>
                </div>
              </th>
            </ng-container>

            <!-- Software Version Column -->
            <ng-container matColumnDef="softwareversion">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="softwareversion" style="width:10%">Software Version</th>
              <td mat-cell *matCellDef="let element" style="width:10%">
                @if (!element.isNewRow) {
                  <div [innerHTML]="element.softwareVersion"></div>
                }
                @if (element.isNewRow) {
                  <mat-form-field style="width: 100%">
                    <input matInput type="text"
                      [ngModelOptions]="{standalone: true}"
                      [(ngModel)]="element.softwareVersion"
                      maxlength="50"
                      matTooltip="Max 50 characters"
                      (keydown)="checkInput($event)" />
                    </mat-form-field>
                  }
                </td>
              </ng-container>

              <!-- Release Name -->
              <ng-container matColumnDef="releasename">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="releasename" style="width:15%">Release Name</th>
                <td mat-cell *matCellDef="let element" style="width:15%">
                                <textareaoverlay [inputControls]="{
                                                     isOpenOverlay: element.isOpenOverlay,
                                                     textAreaId: element.textAreaId,
                                                     isEditable: !element.isEditable,
                                                     maxCommentLength: element.maxCommentLength,
                                                     placeholder: 'Add a Release Name',
                                                     comment: element.releaseName
                                                     }"
                    [customSpanClass]="{'alternative2': !element.isEditable}"
                    (commentChange)="onReleaseNameChange($event.comment, element)">
                  </textareaoverlay>
                </td>
              </ng-container>

              <!-- TDC Agent Version Column -->
              <ng-container matColumnDef="agentversion">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="agentversion" style="width:10%">Agent Version</th>
                <td mat-cell *matCellDef="let element" style="width:10%">
                  @if (!element.isNewRow) {
                    <div [innerHTML]="element.tdcAgentVersion"></div>
                  }
                  @if (element.isNewRow) {
                    <mat-form-field style="width: 100%">
                      <input matInput type="text"
                        [ngModelOptions]="{standalone: true}"
                        [(ngModel)]="element.tdcAgentVersion"
                        maxlength="10"
                        matTooltip="Max 10 characters" />
                      </mat-form-field>
                    }
                  </td>
                </ng-container>

                <!-- Family Code Column -->
                <ng-container matColumnDef="familycode">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="familycode" style="width:15%">Family Code</th>
                  <td mat-cell *matCellDef="let element" style="width:15%">
                    @if (element.isEditable) {
                      <div [innerHTML]="getFamilyCodeText(element.familyCodeId)"></div>
                    }
                    @if (!element.isEditable) {
                      <mat-form-field floatLabel="auto">
                        <mat-select style="min-width: 200px; color:red" [(ngModel)]="element.familyCodeId"
                          [ngModelOptions]="{standalone: true}" panelWidth="auto">
                          <mat-option [value]="-1" [disabled]="true">Select</mat-option>
                          @for (fc of availableFamilyCodes; track fc) {
                            <mat-option [value]="fc.familyCodeId">
                              {{getFamilyCodeText(fc.familyCodeId)}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                  </td>
                </ng-container>

                <!-- Product usage Column -->
                <ng-container matColumnDef="productusage">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="productusage" style="width:10%">Product usage</th>
                  <td mat-cell *matCellDef="let element" style="width:10%">
                    @if (element.isEditable) {
                      <div [innerHTML]="getProductUsageText(element.productUsageId)"></div>
                    }
                    @if (!element.isEditable) {
                      <mat-form-field floatLabel="auto">
                        <mat-select style="min-width: 200px; color:red" [(ngModel)]="element.productUsageId"
                          [ngModelOptions]="{standalone: true}" panelWidth="auto">
                          <mat-option [value]="-1" [disabled]="false">Select</mat-option>
                          @for (fc of availableProductUsages; track fc) {
                            <mat-option [value]="fc.productUsageID">
                              {{getProductUsageText(fc.productUsageID)}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                  </td>
                </ng-container>

                <!-- Release Date Column -->
                <ng-container matColumnDef="releasedate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="releasedate" style="width:10%">Release UTC Date</th>
                  <td mat-cell *matCellDef="let element" style="width:10%">
                    @if (element.isEditable) {
                      <div [innerHTML]="datePipe.transform(element.releaseDate,'yyyy-MM-dd')"></div>
                    }
                    @if (!element.isEditable) {
                      <mat-form-field>
                        <input matInput [matDatepicker]="picker"
                          [ngModelOptions]="{standalone: true}"
                          [(ngModel)]="element.releaseDate"
                          (dateChange)="getDateUTCChange(element, $event)" />
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                      }
                    </td>
                  </ng-container>

                  <!-- Comment Column -->
                  <ng-container matColumnDef="comment">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="comment" style="width:10%">Comment</th>
                    <td mat-cell *matCellDef="let element" style="width:10%">
                                <textareaoverlay [inputControls]="{
                                                     isOpenOverlay: element.isOpenOverlay,
                                                     textAreaId: element.textAreaId,
                                                     isEditable: !element.isEditable,
                                                     maxCommentLength: element.maxCommentLength,
                                                     comment: element.comment
                                                     }"
                        [customSpanClass]="{'alternative2': !element.isEditable}"
                        (commentChange)="onCommentChange($event.comment, element)">
                      </textareaoverlay>
                    </td>
                  </ng-container>

                  <!-- Compatibility Column -->
                  <ng-container matColumnDef="compatibility">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="compatibility" style="width:10%">Compatibility</th>
                    <td *matCellDef="let element;" style="width:10%">
                      @if (element.isEditable) {
                        <div [innerHTML]="getCompatibilityText(element.globalControllerGroupId)"></div>
                      }
                      @if (!element.isEditable) {
                        <mat-form-field floatLabel="auto">
                          <mat-select style="min-width: 200px; color:red"
                            [(ngModel)]="element.globalControllerGroupId"
                            [ngModelOptions]="{standalone: true}" panelWidth="auto">
                            <mat-option>
                              <ngx-mat-select-search [formControl]="filterControl" [placeholderLabel]="'Select...'"></ngx-mat-select-search>
                            </mat-option>
                            @for (gcg of filteredControllerGroups | async; track gcg) {
                              <mat-option [value]="gcg.globalControllerGroupId">
                                {{getCompatibilityText(gcg.globalControllerGroupId)}}
                              </mat-option>
                            }
                            <mat-option [value]="null" (click)="openCreateCompatibilityDialog(element.controllerSoftwareVersionID)">
                              + Create new compatibility
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      }
                    </td>
                  </ng-container>

                  <!-- Is Compatible With Ota2 -->
                  <ng-container matColumnDef="isCompatibleOta2">
                    <th mat-header-cell *matHeaderCellDef>
                      Compatible w/ OTA2
                    </th>
                    <td mat-cell *matCellDef="let element">
                      @if (element.isEditable) {
                        <div>
                          {{ element.isCompatibleOta2 ? 'Yes' : 'No' }}
                        </div>
                      }
                      @if (!element.isEditable) {
                        <mat-checkbox
                          [(ngModel)]="element.isCompatibleOta2"
                          [ngModelOptions]="{standalone: true}">
                        </mat-checkbox>
                      }
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef style="width:10%"></th>
                    <td mat-cell
                      *matCellDef="let element" style="width:10%">

                      <button mat-icon-button
                        matTooltip="Show details"
                        color="warn"
                        (click)="showDetails(getCSRRowFormGroup(element.controllerSoftwareVersionID), element.controllerSoftwareVersionID)">
                        <mat-icon class="actionButtons">remove_red_eye</mat-icon>
                      </button>

                      @if (!element.isEditable) {
                        <button mat-icon-button
                          matTooltip="Cancel Changes"
                          color="warn"
                          (click)="resetRowByID(element.controllerSoftwareVersionID)">
                          <mat-icon class="actionButtons">rotate_left</mat-icon>
                        </button>
                      }

                      @if (element.isEditable) {
                        <button mat-icon-button
                          matTooltip="Edit"
                          color="primary"
                          (click)="editRowByID(element.controllerSoftwareVersionID)">
                          <mat-icon class="actionButtons">edit</mat-icon>
                        </button>
                      }

                      <!-- <button mat-icon-button
                      *ngIf="false"
                      matTooltip="Delete"
                      color="warn"
                      (click)="deleteRow(i)">
                      <mat-icon>delete</mat-icon>
                    </button> -->
                  </td>
                </ng-container>
                <ng-container matColumnDef="savefooter">
                  <th mat-footer-cell *matFooterCellDef colspan="10">
                    <div class="OrangeButton">
                      <button mat-raised-button type="submit" (click)="onSave()"
                        [disabled]="!anyChange()"
                        [matTooltip]="anyChange()? 'Save changes' : 'Save disabled'"
                        class="button-color-fix pull-right">
                        Save
                        <mat-icon style="color:white !important" class="icon-color-fix">save</mat-icon>
                      </button>
                    </div>
                  </th>

                </ng-container>
                <tr mat-header-row *matHeaderRowDef="['headertitle', 'headeraddbutton']; sticky: true" class="stickyTopz100"></tr>
                <tr class="col-headers" mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; let i = index; columns: columnsToDisplay;" [class.alternative2]="!row.isEditable"></tr>
                <tr mat-footer-row *matFooterRowDef="['savefooter']; sticky: true"></tr>
              </table>
            </ng-container>
          </form>
        </div>
      </div>

    </div>
